<template>
    <div class="top-collections-carousel">
        <vueper-slides class="no-shadow"
                       :visible-slides="mobileCheck? 1 : 3"
                       :arrows="false"
                       :infinite="false"
                       :autoplay="true"
                       :slide-ratio="1 / 2"
                       :gap="mobileCheck? 0 : 3"
                       :dragging-distance="70" ref="myVueperSlides">
            <vueper-slide v-for="(item, index) in collectionsList" :key="item.id">
                <template #content>
                    <v-card class="collection-item">
                        <v-card-text>
                            <div :class="{ 'additional-info': true, 'last-item': index===2 || index===5 }">
                                <div class="additional-info-subtitle">{{ $t('collections1') }}</div>
                                <div class="additional-info-title">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                                <div class="additional-info-wines" v-for="(wine, wineIndex) in item.wines" :key="wineIndex">
                                    <div class="additional-info-title">
                                        <div class="country-flag" :style="{ background: `url(${wine.countryFlagUrl}) no-repeat center` }"></div>
                                        <div v-if="wine.displayWineName">
                                            <div class="wine-vintage-name">{{wine.displayWineName}}</div>
                                        </div>
                                        <div v-else-if="wine.wineName">
                                            <div class="wine-vintage-name">{{wine.vintage}} {{wine.wineName}}</div>
                                        </div>
                                        <div v-else>
                                            <div class="wine-vintage-name">{{wine.vintage}} {{wine.producerName}} asd</div>
                                        </div>
                                    </div>
                                    <div class="additional-info-subtitle">{{wine.caseQuantity}} {{wine.caseQuantity > 1 ? 'cases' : 'case'}} of {{wine.caseSize}}</div>
                                </div>
                                <div class="arrow-right"></div>
                                <div class="arrow-left"></div>
                            </div>
                            <div class="header-img" :style="getImgUrl(item.picture)"></div>

                            <div class="background-shadow" v-on:click="() => { openCollection(item) }">
                                <h3 class="collection-header">{{item.title}}</h3>
                            </div>

                            <div class="investment-horizon-wrapper">
                                <div class="investment">{{ $t('collections1') }}</div>
                                <div :class="{'investments-percentages': true, 'investments-percentages-2': item.investmentHorizon === 2, 'investments-percentages-3': item.investmentHorizon === 3}">
                                    <div class="collection-percent"></div>
                                    <div class="collection-percent"></div>
                                    <div class="collection-percent"></div>
                                </div>
                                <div class="investment-years">{{item.investmentHorizon === 3 ? $t('collections4') : (item.investmentHorizon === 2 ? $t('collections2') : $t('collections3'))}}</div>
                            </div>

                            <div class="collection-subtitle">{{item.subtitle}}</div>

                            <div class="collection-price-wrapper">
                                <div class="investments-wrapper-left">
                                    <div class="collection-price">{{formatPrice(item.price.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                                    <div class="collections-save">{{ $t('collections5') }} {{formatPrice(item.youSave.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}</div>
                                </div>
                                <div class="investments-wrapper-right">
                                    <div v-if="item.availableQuantity !== 0">
                                        <button :class="$i18n.locale.toLowerCase() === 'fr' ? 'cart-btn-fr' : ($i18n.locale.toLowerCase() === 'it' ? 'cart-btn-it' : 'cart-btn')" v-on:click="() => { addCollectionToCart(item) }">{{ $t('add-basket') }}</button>
                                    </div>
                                    <div v-else>
                                        <div :class="$i18n.locale.toLowerCase() === 'fr' ? 'sold-label-fr' : 'sold-label'">{{ $t('sold-out') }}</div>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </template>
            </vueper-slide>
        </vueper-slides>

        <div class="btns-container">
            <button @click="$refs.myVueperSlides.previous()" class="back-btn"></button>
            <button @click="$refs.myVueperSlides.next()" class="next-btn"></button>
        </div>
    </div>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import { mapGetters } from "vuex";
import {AOrders, AUser} from '@/store/actions';
import {MOrders} from "@/store/mutations";
import {GCommon, GOrders} from "@/store/getters";

export default {
    name: "HomeTopCollectionsCarousel",
    props: ['collectionsList'],
    components: {VueperSlides, VueperSlide},
    data () {
        return {
            windowWidth: null,
            swiperOption2: {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            cartItemsList: GOrders.GET_CART_ITEMS,
            mobileCheck: GCommon.GET_MOBILE_VERSION
        })
    },
    methods: {
        formatPrice(price) {
            return `€${price}`
        },
        openCollection(item) {
            if (this.goToDetailsPage) {
                return;
            }
            this.goToDetailsPage = true;
            let wineCollectionsView = this;
            this.$store.dispatch(AOrders.GET_COLLECTION_DETAILS, { id: item.id, lang: this.$i18n.locale }).then(() => {
                setTimeout(function() {
                    wineCollectionsView.goToDetailsPage = false
                }, 800);
                this.$store.dispatch(AUser.GET_USER_COMMISSION);
                this.$store.dispatch(AUser.GET_ADDRESSES);
                this.$router.push(this.localePath({ path: `/collection-details/${item.id}` }));
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            })
        },
        addCollectionToCart (collection) {
            let _payload = {};
            let availableInCart = this.cartItemsList.filter(item => item.id === collection.id);
            let availableInCartGifts = this.cartItemsList.filter(item => item.christmasGift === true);

            if (availableInCart.length) {
                if (availableInCart[0].unitsCount >= collection.availableQuantity) {
                    alert('There are not enough collections on the market');
                    return;
                }
            }

            if (availableInCartGifts.length) {
                this.$nuxt.$emit('carterror', false);
                return;
            }

            this.$gtm.push({ ecommerce: null });
            this.$gtm.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: "EUR",
                    value: collection.price,
                    purchase: {
                        price: collection.price,
                        id: Math.floor(Math.random() * 10000) + 1
                    },
                    items: [
                        {
                            item_id: collection.id,
                            item_name: collection.title,
                            coupon: "",
                            discount: 0,
                            index: 0,
                            item_brand: "Vindome Wine Collection",
                            item_category: "Wine collection",
                            item_list_id: "wine_collections",
                            price: collection.price,
                            quantity: 1
                        }
                    ]
                }
            });

            _payload.availableQuantity = collection.availableQuantity;
            _payload.collectionOrderIds = collection.collectionOrderIds;
            _payload.investmentHorizon = collection.investmentHorizon;
            _payload.isEnPrimeur = collection.isEnPrimeur;
            _payload.id = collection.id;
            _payload.price = collection.price;
            _payload.title = collection.title;
            _payload.picture = collection.picture;
            _payload.unitsCount = 1;
            _payload.youSave = collection.youSave;
            _payload.totalCases = 0;
            _payload.wines = [];

            collection.wines.forEach(element => {
                let _wine = {};
                _wine.caseQuantity = element.caseQuantity;
                _wine.pricePerCase = element.pricePerCase;
                _payload.wines.push(_wine);
                _payload.totalCases += element.caseQuantity;
            });
            this.$store.commit(MOrders.SET_COLLECTION_CART, { collections: _payload, addRemove: true, resetCart: false });
        },
        getImgUrl(imgUrl) {
            return "background-image: url('" + imgUrl + "')"
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;
    }
}
</script>

<style scoped>
.btns-container {
    display: flex;
    align-content: center;
    justify-content: center;
    gap: 32px;
    margin-top: 20px;
}
.back-btn {
    background: url("../../assets/home/testimonials_left.png") no-repeat center;
    background-size: contain;
    width: 44px;
    height: 44px;
}
.next-btn {
    background: url("../../assets/home/testimonials_right.png") no-repeat center;
    background-size: contain;
    width: 44px;
    height: 44px;
}
.collection-price-wrapper {
    padding: 0 10px 10px;
}
.sold-label {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 130px;
    height: 36px;
    background: #efefef;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #000;
    margin-top: 6px;
    text-align: center;
    float: right;
}
.sold-label-fr {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 130px;
    height: 36px;
    background: #efefef;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #000;
    margin-top: 34px;
    text-align: center;
    float: right;
}
.additional-info {
    display: none;
    padding: 18px;
    background: #FFFFFF;
    border-radius: 8px;
    -webkit-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
    -moz-box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.75);
    position: absolute;
    left: calc(100% - 14px);
    z-index: 3;
    width: 100%;
}
.additional-info.last-item {
    left: unset;
    right: calc(100% - 14px);
}
.arrow-right {
    content: '';
    vertical-align: middle;
    margin: auto;
    position: absolute;
    top: 0;
    left: -8px;
    bottom: 0;
    width: 15px;
    height: 15px;
    background: #fff;
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    -moz-transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}
.arrow-left {
    content: '';
    display: none;
    vertical-align: middle;
    margin: auto;
    position: absolute;
    top: 0;
    right: -8px;
    bottom: 0;
    width: 15px;
    height: 15px;
    background: #fff;
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}
.additional-info.last-item .arrow-right {
    display: none;
}
.additional-info.last-item .arrow-left {
    display: block;
}

.additional-info-wines {
    margin-top: 16px;
}
.additional-info-subtitle {
    font-family: Roboto, sans-serif;
    size: 14px;
    line-height: 19px;
    color: #707070;
}
.additional-info-title {
    font-family: Roboto, sans-serif;
    size: 16px;
    line-height: 19px;
    color: #000000;
    font-weight: 500;
    position: relative;
}
.country-flag {
    width: 30px;
    height: 15px;
    background-size: contain !important;
    display: block;
    top: 1px;
    position: absolute;
}
.wine-vintage-name {
    display: inline-block;
    text-indent: 40px;
}
.background-shadow {
    background: linear-gradient(180deg, rgba(0, 48, 77, 0) 0%, #00304D 100%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 188px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
.background-shadow:hover {
    cursor: pointer;
}
.collection-item {
    display: inline-block;
    width: 100%;
    vertical-align: top;
    border-radius: 9.6px;
    background: white !important;
    /*box-shadow: 0 0 32px 10px rgba(0, 40, 64, 0.50) !important;*/
    box-shadow: none !important;
}
.collection-item:hover {
    cursor: pointer;
}
.collection-item:hover .additional-info {
    display: block;
}
.collection-item:nth-child(3n+0) {
    margin-right: 0;
}
.header-img {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
    height: 188px;
    position: relative;
    background-size: cover;
    background-position-y: center;
}
.collection-header {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    color: #ffffff;
    position: absolute;
    bottom: 16px;
    left: 16px;
    white-space: pre-line;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    z-index: 2;
    width: calc(100% - 32px);
}
.background-shadow:hover .collection-header {
    color: var(--brand)
}
.collection-subtitle {
    height: 66px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
    margin: 8px 0 16px;
    padding-left: 10px;
    padding-right: 10px;
}
.investments-wrapper-left,
.investments-wrapper-right {
    display: inline-block;
    width: calc(50% - 2px);
    vertical-align: top;
}
.investments-wrapper-right {
    text-align: right;
}
.investments-percentages {
    height: 4px;
}
.investments-percentages .collection-percent {
    display: inline-block;
    width: calc((100% - 8px) / 3);
    background: rgba(0, 0, 0, 0.16);
    height: 4px;
    border-radius: 2px;
    vertical-align: top;
}
.investments-percentages .collection-percent:nth-child(1),
.investments-percentages.investments-percentages-2 .collection-percent:nth-child(2),
.investments-percentages.investments-percentages-3 .collection-percent:nth-child(2),
.investments-percentages.investments-percentages-3 .collection-percent:nth-child(3) {
    background: #E5CB87;
}
.cart-btn {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 120px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: white;
    margin-top: 6px;
}
.cart-btn-it {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 4px 16px;
    width: 120px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 13px;
    color: white;
    margin-top: 6px;
}
.cart-btn-fr {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 145px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: white;
    margin-top: 34px;
}
.collection-price {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #002840;
    margin-bottom: 2px;
}
.collections-save {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
}
.investment-horizon-wrapper {
    height: 64px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 0 0 8px 8px;
    padding: 8px 10px;
}
.investment {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #002840;
}


@media(min-width: 768px) and (max-width: 1024px) {
    .collection-item {
        width: 380px;
        margin: 0 auto 20px;
        box-sizing: border-box;
        display: block;
    }
}

@media(max-width: 767px) {
    .swiper-button-next,
    .swiper-button-prev {
        display: none;
    }
    .collection-item {
        width: 100%;
        margin-right: 0;
        margin-left: 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }
    .collection-item:hover .additional-info {
        display: none;
    }
}
</style>

<style>
.collection-item .v-card__text {
    padding: 0;
}
.home .home-more-collections .swiper-container {
    height: 380px !important;
    margin-bottom: 32px;
}
.top-collections-carousel .vueperslides {
    height: 468px;
    margin: 0 auto;
    max-width: 1126px;
}
.top-collections-carousel .vueperslides__parallax-wrapper {
    height: 468px;
}
.top-collections-carousel .vueperslide {
    transform: scale(0.7);
    margin-right: 0 !important;
    transition: transform 1s;
    margin-top: 20px;
}
.top-collections-carousel .vueperslide:hover {
    z-index: 9999999999;
}
.top-collections-carousel .vueperslide.vueperslide--active {
    transform: scale(1);
    padding: 35px 20px;
    margin-top: 0;
    margin-right: 0 !important;
}
.top-collections-carousel .vueperslide.vueperslide--active .collection-item {
    box-shadow: 0 0 32px 10px rgba(0, 40, 64, 0.50) !important;
}
</style>
